import React from 'react';
import { Box, Typography } from '@mui/material';

import { v2Colors } from '../../design/theme';

const FORMAT_MEAT = 'meat';

function FormatCard({
  title,
  price,
  footnote,
  selected,
  disabled,
  onClick,
  compact = false,
}) {
  return (
    <Box
      component={disabled ? 'div' : 'button'}
      type={disabled ? undefined : 'button'}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      sx={{
        flex: '1 1 calc(50% - 6px)',
        maxWidth: 'calc(50% - 6px)',
        minWidth: 0,
        textAlign: 'left',
        p: compact ? 1.1 : 1.75,
        borderRadius: compact ? 2 : 2.5,
        border: compact ? '1.5px solid' : '2px solid',
        borderColor: selected ? v2Colors.primary : v2Colors.borderMuted,
        bgcolor: selected ? v2Colors.selectedFill : v2Colors.white,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.72 : 1,
        fontFamily: 'inherit',
        display: 'block',
        transition: 'border-color 0.15s, background-color 0.15s',
        '&:hover': disabled
          ? {}
          : {
              borderColor: v2Colors.primary,
            },
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: compact ? '0.8rem' : '0.95rem',
          color: v2Colors.heading,
          lineHeight: 1.3,
          mb: compact ? 0.5 : 0.75,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: compact ? '1.05rem' : '1.35rem',
          color: v2Colors.primary,
          lineHeight: 1.2,
          mb: footnote ? (compact ? 0.35 : 0.75) : 0,
        }}
      >
        {price}
      </Typography>
      {footnote ? (
        <Typography
          sx={{
            fontSize: compact ? '0.7rem' : '0.8rem',
            color: v2Colors.textMuted,
            lineHeight: 1.35,
          }}
        >
          {footnote}
        </Typography>
      ) : null}
    </Box>
  );
}

/**
 * @param {{
 *   meatPrice: number|string,
 *   meatWeightLine: string|null,
 *   liveBirdPriceLabel: string|null,
 *   format: 'meat'|'live_bird',
 *   onSelectMeat: () => void,
 *   compact?: boolean,
 * }} props
 */
export default function ProductChooseFormat({
  meatPrice,
  meatWeightLine,
  liveBirdPriceLabel,
  format,
  onSelectMeat,
  compact = false,
}) {
  return (
    <Box
      sx={{
        mb: compact ? 1.5 : 2.5,
        p: compact ? 1.25 : 2,
        borderRadius: compact ? 2 : 3,
        border: `1px solid ${v2Colors.borderMuted}`,
        bgcolor: v2Colors.white,
      }}
    >
      <Typography
        sx={{
          fontSize: '0.68rem',
          fontWeight: 700,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: v2Colors.heading,
          mb: compact ? 1 : 1.5,
        }}
      >
        Choose format
      </Typography>
      <Box sx={{ display: 'flex', gap: compact ? 1 : 1.25 }}>
        <FormatCard
          compact={compact}
          title="Meat (cut & cleaned)"
          price={`₹${meatPrice}`}
          footnote={meatWeightLine}
          selected={format === FORMAT_MEAT}
          onClick={onSelectMeat}
        />
        {liveBirdPriceLabel ? (
          <FormatCard
            compact={compact}
            title="Live bird"
            price={liveBirdPriceLabel}
            footnote="In-store only"
            selected={format === 'live_bird'}
            disabled
          />
        ) : null}
      </Box>
    </Box>
  );
}

export { FORMAT_MEAT };
